/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "@mui/styled-engine-sc";
import Step from "@mui/material/Step";

const StyledStep = styled(({ ...props }) => <Step {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledStep };
